export default __webpack_public_path__ + "static/media/red_gift_gold_ribbon.27e3dee5.png";